import {
	Component,
	ElementRef,
	EventEmitter,
	HostListener,
	Input,
	OnChanges,
	OnInit,
	Output,
	SimpleChanges,
	ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { FreudMenuItem } from '@freud-ds/web-components';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from 'app/services/authentication.service';
import { GlobalService } from 'app/services/global.service';
import { ShellTrackersService } from 'modules/shell/services/shell-trackers.service';

@Component({
	selector: 'header-submenu',
	templateUrl: './header-submenu.component.html',
	styleUrls: ['./header-submenu.component.scss'],
})
export class HeaderSubmenuComponent implements OnInit, OnChanges {
	@Input() userData;
	@Input() isUserVisible = false;
	@Input() isUserActive = null;
	@Output() onClose = new EventEmitter();
	@Output() onChangeStatus = new EventEmitter();
	@ViewChild('submenu', { read: ElementRef }) subMenuDOMElement: ElementRef;
	isMobile = false;
	menuItems: FreudMenuItem[] = [];
	constructor(
		private router: Router,
		private authenticationService: AuthenticationService,
		private global: GlobalService,
		public shellTracker: ShellTrackersService,
		public translateService: TranslateService
	) {}

	ngOnInit(): void {
		this.windowResized();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.isUserActive) {
			this.setMenuItems();
		}
	}

	redirectTo(url) {
		this.router.navigateByUrl(url);
		this.onClose.emit();
	}

	openZenklubProfile() {
		window.open(this.userData.profileUrl, '_blank', 'noopener');
	}

	logout() {
		this.authenticationService.logout();
	}

	windowResized() {
		this.isMobile = this.global.isMobileDevice();
		this.setMenuItems();
	}

	@HostListener('document:mousedown', ['$event'])
	onGlobalClick(event): void {
		if (event?.target?.classList.contains('p-avatar-icon')) {
			event.preventDefault();
			return;
		}
		if (!this.subMenuDOMElement.nativeElement.contains(event.target)) {
			this.onClose.emit();
		}
	}

	trackToggle(e) {
		this.shellTracker.trackHeaderMenuItemClick('status', {
			status: e ? 'online' : 'offline',
		});
	}

	setMenuItems() {
		console.log('isUserActive', this.isUserActive);
		this.menuItems = [
			{
				label: '✨ ClariPro',
				icon: '',
				command: () => {
					this.shellTracker.trackHeaderMenuItemClick('clari');
					window.open(
						`${window.location.origin}/clari/pro`,
						'_blank',
						'noopener'
					);
				},
			},
			{
				label: 'Agenda',
				icon: 'freud-icon freud-icon-calendar-event',
				command: () => {
					this.shellTracker.trackHeaderMenuItemClick('calendar');
					this.redirectTo('/calendar');
				},
			},
			{
				label: 'Disponibilidades',
				icon: 'freud-icon freud-icon-edit',
				command: () => {
					this.shellTracker.trackHeaderMenuItemClick('availabilities');
					this.redirectTo('/availabilities');
				},
			},
			{
				label: 'Clientes',
				icon: 'freud-icon freud-icon-user-circle',
				command: () => {
					this.shellTracker.trackHeaderMenuItemClick('contacts');
					this.redirectTo('/contacts');
				},
			},
			{
				label: 'Financeiro',
				icon: 'freud-icon freud-icon-receipt-2',
				command: () => {
					this.shellTracker.trackHeaderMenuItemClick('financials');
					this.redirectTo('/financials');
				},
			},
			{
				label: 'Minha conta',
				icon: 'freud-icon freud-icon-user',
				command: () => {
					this.shellTracker.trackHeaderMenuItemClick('account');
					this.redirectTo('/account');
				},
			},
			{
				label: 'Assinatura',
				icon: 'freud-icon freud-icon-diamond',
				command: () => {
					this.shellTracker.trackHeaderMenuItemClick('subscription');
					this.redirectTo('/account/premium');
				},
			},
			{
				label: 'Meu perfil no Zenklub',
				icon: 'freud-icon freud-icon-external-link',
				command: () => {
					this.shellTracker.trackHeaderMenuItemClick('profile');
					this.openZenklubProfile();
				},
				tooltipOptions: !this.isUserActive
					? {
							tooltipLabel: this.translateService.instant(
								'MENU.PROFILE_TOOLTIP'
							),
							tooltipPosition: 'left',
							tooltipEvent: 'hover',
					  }
					: null,
				disabled: !this.isUserActive,
			},
			{
				label: 'Sair',
				icon: 'freud-icon freud-icon-logout',
				command: () => {
					this.shellTracker.trackHeaderMenuItemClick('logout');
					this.logout();
				},
			},
		];
		if (!this.isMobile) {
			this.menuItems.splice(0, 5);
		}
	}
}
